module.exports = "<app-navigation></app-navigation>\n<app-navigation-questionnaire></app-navigation-questionnaire>\n<app-header></app-header>\n<app-header-questionnaire></app-header-questionnaire>\n<router-outlet></router-outlet>\n<app-cookie-popup\n  *ngIf=\"!checkForConsented()\"\n  (consent)=\"onConsentStatusChange($event)\"\n></app-cookie-popup>\n"


//////////////////
// WEBPACK FOOTER
// /agir/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main